(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("SolidLogic"), require("UI"));
	else if(typeof define === 'function' && define.amd)
		define(["SolidLogic", "UI"], factory);
	else if(typeof exports === 'object')
		exports["FolderPane"] = factory(require("SolidLogic"), require("UI"));
	else
		root["FolderPane"] = factory(root["SolidLogic"], root["UI"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__663__, __WEBPACK_EXTERNAL_MODULE__426__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 136
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folderPaneInstancePane {
  box-sizing: border-box;
  align-self: stretch;
  text-align: left;
  width: 100%;
  max-width: none;
  margin-left: 0;
  margin-right: 0;
  border-top: solid 1px #777;
  border-bottom: solid 1px #777;
  margin-top: var(--spacing-xs, 0.5em);
  margin-bottom: var(--spacing-xs, 0.5em);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.folderPanePackageDiv {
  display: block;
  text-align: left;
  width: 100%;
  max-width: none;
  margin-left: 0;
  margin-right: 0;
  border-top: 0.2em solid #ccc;
  overflow-x: auto;
}

.folderPaneMainTable {
  display: table;
  width: 100%;
  max-width: none;
  table-layout: auto;
  text-align: left;
  margin-left: 0;
  margin-right: auto;
  margin-bottom: var(--spacing-lg, 1.5625rem);
}

.folderPaneMainTable td,
.folderPaneMainTable th {
  text-align: left;
  vertical-align: top;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* manager.js sets inline padding:0 on object cells; use an important override here */
.folderPaneMainTable > tr > td.obj,
.folderPaneMainTable > tbody > tr > td.obj {
  padding-left: var(--spacing-lg, 1.5625rem) !important;
}

.folderPanePredicateCell {
  width: 0;
  min-width: 0;
  max-width: 0;
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  overflow: hidden;
}

.folderPaneCreationDiv {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: none;
  margin-left: 0;
  margin-right: 0;
}

.folderPaneDropTarget {
  display: inline-block;
  width: var(--icon-base, 2em);
  min-width: var(--icon-base, 2em);
  max-width: var(--icon-base, 2em);
  height: var(--icon-base, 2em);
  min-height: var(--icon-base, 2em);
  max-height: var(--icon-base, 2em);
  padding: 0 !important;
  margin: 0 !important;
  box-sizing: content-box;
  flex: 0 0 var(--icon-base, 2em);
}

.folderPaneExplicitDropIcon {
  width: var(--icon-base, 2em);
  height: var(--icon-base, 2em);
}

@media (max-width: 700px) {
  .folderPaneInstancePane {
    border-top: solid 1px #777;
    border-bottom: solid 1px #777;
    margin-top: var(--spacing-2xs, 0.25em);
    margin-bottom: var(--spacing-2xs, 0.25em);
  }

  .folderPaneExplicitDropIcon {
    width: var(--icon-sm, 1.5em);
    height: var(--icon-sm, 1.5em);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/folderPane.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,uCAAuC;EACvC,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,qFAAqF;AACrF;;EAEE,qDAAqD;AACvD;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,sCAAsC;IACtC,yCAAyC;EAC3C;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF","sourcesContent":[".folderPaneInstancePane {\n  box-sizing: border-box;\n  align-self: stretch;\n  text-align: left;\n  width: 100%;\n  max-width: none;\n  margin-left: 0;\n  margin-right: 0;\n  border-top: solid 1px #777;\n  border-bottom: solid 1px #777;\n  margin-top: var(--spacing-xs, 0.5em);\n  margin-bottom: var(--spacing-xs, 0.5em);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.folderPanePackageDiv {\n  display: block;\n  text-align: left;\n  width: 100%;\n  max-width: none;\n  margin-left: 0;\n  margin-right: 0;\n  border-top: 0.2em solid #ccc;\n  overflow-x: auto;\n}\n\n.folderPaneMainTable {\n  display: table;\n  width: 100%;\n  max-width: none;\n  table-layout: auto;\n  text-align: left;\n  margin-left: 0;\n  margin-right: auto;\n  margin-bottom: var(--spacing-lg, 1.5625rem);\n}\n\n.folderPaneMainTable td,\n.folderPaneMainTable th {\n  text-align: left;\n  vertical-align: top;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* manager.js sets inline padding:0 on object cells; use an important override here */\n.folderPaneMainTable > tr > td.obj,\n.folderPaneMainTable > tbody > tr > td.obj {\n  padding-left: var(--spacing-lg, 1.5625rem) !important;\n}\n\n.folderPanePredicateCell {\n  width: 0;\n  min-width: 0;\n  max-width: 0;\n  padding: 0 !important;\n  margin: 0 !important;\n  border: 0 !important;\n  overflow: hidden;\n}\n\n.folderPaneCreationDiv {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  width: 100%;\n  max-width: none;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.folderPaneDropTarget {\n  display: inline-block;\n  width: var(--icon-base, 2em);\n  min-width: var(--icon-base, 2em);\n  max-width: var(--icon-base, 2em);\n  height: var(--icon-base, 2em);\n  min-height: var(--icon-base, 2em);\n  max-height: var(--icon-base, 2em);\n  padding: 0 !important;\n  margin: 0 !important;\n  box-sizing: content-box;\n  flex: 0 0 var(--icon-base, 2em);\n}\n\n.folderPaneExplicitDropIcon {\n  width: var(--icon-base, 2em);\n  height: var(--icon-base, 2em);\n}\n\n@media (max-width: 700px) {\n  .folderPaneInstancePane {\n    border-top: solid 1px #777;\n    border-bottom: solid 1px #777;\n    margin-top: var(--spacing-2xs, 0.25em);\n    margin-bottom: var(--spacing-2xs, 0.25em);\n  }\n\n  .folderPaneExplicitDropIcon {\n    width: var(--icon-sm, 1.5em);\n    height: var(--icon-sm, 1.5em);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 92
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Shared utility variables (e.g., base icon size) */
  --icon-base: 2em;
}`, "",{"version":3,"sources":["webpack://./src/styles/utilities.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;EACpD,gBAAgB;AAClB","sourcesContent":[":root {\n  /* Shared utility variables (e.g., base icon size) */\n  --icon-base: 2em;\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 314
(module) {



/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ },

/***/ 354
(module) {



module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ },

/***/ 72
(module) {



var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ },

/***/ 659
(module) {



var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ },

/***/ 540
(module) {



/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ },

/***/ 56
(module, __unused_webpack_exports, __webpack_require__) {



/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ },

/***/ 825
(module) {



/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ },

/***/ 113
(module) {



/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ },

/***/ 663
(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__663__;

/***/ },

/***/ 426
(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__426__;

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_folderPane)
});

// EXTERNAL MODULE: external "SolidLogic"
var external_SolidLogic_ = __webpack_require__(663);
// EXTERNAL MODULE: external "UI"
var external_UI_ = __webpack_require__(426);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(72);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(825);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(659);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(56);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(540);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(113);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/folderPane.css
var folderPane = __webpack_require__(136);
;// ./src/styles/folderPane.css

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());
options.insert = insertBySelector_default().bind(null, "head");
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(folderPane/* default */.A, options);




       /* harmony default export */ const styles_folderPane = (folderPane/* default */.A && folderPane/* default */.A.locals ? folderPane/* default */.A.locals : undefined);

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/utilities.css
var utilities = __webpack_require__(92);
;// ./src/styles/utilities.css

      
      
      
      
      
      
      
      
      

var utilities_options = {};

utilities_options.styleTagTransform = (styleTagTransform_default());
utilities_options.setAttributes = (setAttributesWithoutAttributes_default());
utilities_options.insert = insertBySelector_default().bind(null, "head");
utilities_options.domAPI = (styleDomAPI_default());
utilities_options.insertStyleElement = (insertStyleElement_default());

var utilities_update = injectStylesIntoStyleTag_default()(utilities/* default */.A, utilities_options);




       /* harmony default export */ const styles_utilities = (utilities/* default */.A && utilities/* default */.A.locals ? utilities/* default */.A.locals : undefined);

;// ./src/folderPane.ts
/*   Folder pane
 **
 **  This outline pane lists the members of a folder
 */





/* harmony default export */ const src_folderPane = ({
  icon: external_UI_.icons.iconBase + 'noun_973694_expanded.svg',
  name: 'folder',
  // Create a new folder in a Solid system,
  mintNew: function (context, newPaneOptions) {
    const kb = context.session.store;
    const newInstance = newPaneOptions.newInstance || kb.sym(newPaneOptions.newBase);
    let u = newInstance.uri;
    if (u.endsWith('/')) {
      u = u.slice(0, -1); // chop off trailer
    } // { throw new Error('URI of new folder must end in "/" :' + u) }
    newPaneOptions.newInstance = kb.sym(u + '/');
    return kb.fetcher.webOperation('PUT', newInstance.uri).then(function () {
      console.log('New container created: ' + newInstance.uri);
      return newPaneOptions;
    });
  },
  label: function (subject, context) {
    const kb = context.session.store;
    const n = kb.each(subject, external_UI_.ns.ldp('contains')).length;
    if (n > 0) {
      return 'Contents (' + n + ')'; // Show how many in hover text
    }
    if (kb.holds(subject, external_UI_.ns.rdf('type'), external_UI_.ns.ldp('Container'))) {
      // It is declared as being a container
      return 'Container (0)';
    }
    return null; // Suppress pane otherwise
  },
  // Render a file folder in a LDP/solid system
  render: function (subject, context) {
    function noHiddenFiles(obj) {
      // @@ This hiddenness should actually be server defined
      const pathEnd = obj.uri.slice(obj.dir().uri.length);
      return !(pathEnd.startsWith('.') || pathEnd.endsWith('.acl') || pathEnd.endsWith('~'));
    }
    function refresh() {
      let objs = kb.each(subject, external_UI_.ns.ldp('contains')).filter(noHiddenFiles);
      objs = objs.map(obj => [external_UI_.utils.label(obj).toLowerCase(), obj]);
      objs.sort(); // Sort by label case-insensitive
      objs = objs.map(pair => pair[1]);
      external_UI_.utils.syncTableToArray(mainTable, objs, function (obj) {
        const st = kb.statementsMatching(subject, external_UI_.ns.ldp('contains'), obj)[0];
        const defaultpropview = outliner.VIEWAS_boring_default;
        const tr = outliner.propertyTR(dom, st, false);
        const predicateCell = tr.firstChild;
        predicateCell.textContent = ''; // Was initialized to 'Contains'
        predicateCell.classList.add('folderPanePredicateCell');
        tr.appendChild(outliner.outlineObjectTD(obj, defaultpropview, undefined, st));
        // UI.widgets.makeDraggable(tr, obj)
        return tr;
      });
    }
    const dom = context.dom;
    const outliner = context.getOutliner(dom);
    const kb = context.session.store;
    let mainTable; // This is a live synced table
    const div = dom.createElement('div');
    div.classList.add('instancePane', 'folderPaneInstancePane');
    const thisDir = subject.uri.endsWith('/') ? subject.uri : subject.uri + '/';
    const indexThing = kb.sym(thisDir + 'index.ttl#this');
    if (kb.holds(subject, external_UI_.ns.ldp('contains'), indexThing.doc())) {
      console.log('View of folder will be view of indexThing. Loading ' + indexThing);
      const packageDiv = div.appendChild(dom.createElement('div'));
      packageDiv.classList.add('folderPanePackageDiv');
      kb.fetcher.load(indexThing.doc()).then(function () {
        mainTable = packageDiv.appendChild(dom.createElement('table'));
        mainTable.classList.add('folderPaneMainTable');
        context.getOutliner(dom).GotoSubject(indexThing, true, undefined, false, undefined, mainTable);
      });
      return div;
    } else {
      mainTable = div.appendChild(dom.createElement('table'));
      mainTable.classList.add('folderPaneMainTable');
      mainTable.refresh = refresh;
      refresh();
      // addDownstreamChangeListener is a high level function which when someone else changes the resource,
      // reloads it into the kb, then must call addDownstreamChangeListener to be able to update the folder pane.
      kb.updater.addDownstreamChangeListener(subject, refresh); // Update store and call me if folder changes
    }

    // Allow user to create new things within the folder
    const creationDiv = div.appendChild(dom.createElement('div'));
    creationDiv.classList.add('folderPaneCreationDiv');
    const me = external_SolidLogic_.authn.currentUser(); // @@ respond to login events
    if (!me) {
      return div; // Cannot create new things without being logged in
    }
    const creationContext = {
      folder: subject,
      div: creationDiv,
      dom: dom,
      statusArea: creationDiv,
      me: me
    };
    creationContext.refreshTarget = mainTable;
    external_UI_.login.filterAvailablePanes(context.session.paneRegistry.list).then(function (relevantPanes) {
      external_UI_.create.newThingUI(creationContext, context, relevantPanes); // Have to pass panes down  newUI

      external_UI_.aclControl.preventBrowserDropEvents(dom);
      const explicitDropIcon = false;
      let target;
      if (explicitDropIcon) {
        target = creationDiv.insertBefore(dom.createElement('img'), creationDiv.firstChild);
        target.classList.add('folderPaneExplicitDropIcon');
        target.setAttribute('src', external_UI_.icons.iconBase + 'noun_748003.svg');
      } else {
        target = creationDiv.firstChild; // Overload drop target semantics onto the plus sign
      }
      if (target instanceof HTMLElement) {
        target.classList.add('folderPaneDropTarget');
      }

      // /////////// Allow new file to be Uploaded
      external_UI_.widgets.makeDropTarget(target, null, droppedFileHandler);
    });
    return div;
    function droppedFileHandler(files) {
      external_UI_.widgets.uploadFiles(kb.fetcher, files, subject.uri, subject.uri, function (file, uri) {
        // A file has been uploaded
        const destination = kb.sym(uri);
        console.log(' Upload: put OK: ' + destination);
        kb.add(subject, external_UI_.ns.ldp('contains'), destination, subject.doc());
        mainTable.refresh();
      });
    }
  }
});
// ends
__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=folder-pane.js.map